import React from "react";
import { TableHeader } from "carbon-react/lib/components/table";
import Icon from "carbon-react/lib/components/icon";

import "./TableHeaderWithSortIndicator.css";

const sortOrder = Object.freeze({
  asc: "asc",
  desc: "desc",
});

const TableHeaderWithSortIndicator = (props) => {
  return (
    <TableHeader className="table-header-with-sort-indicator" id={props.id}>
      <span className="table-header-with-sort-indicator-container">
        {props.children}
        <Icon
          type={
            props.sortOrder && props.sortOrder === sortOrder.asc
              ? "sort_up"
              : "sort_down"
          }
          className="table-header-with-sort-indicator-icon"
        />
      </span>
    </TableHeader>
  );
};

export default TableHeaderWithSortIndicator;
export { sortOrder };
